/**
 * Two-line presentational primitives shared by SignalDetailPage and any
 * other "label : value" card-style view.
 *
 *   <DetailCard title="Peplink">
 *     <DetailRow label="Status">online</DetailRow>
 *     <DetailRow label="Last seen">2026-05-31 12:00</DetailRow>
 *   </DetailCard>
 *
 * Extracted from SignalDetailPage so the page module stays focused on
 * its data-loading + layout concerns.
 */
import React from "react";

export const DetailCard: React.FC<{
  title: string;
  children: React.ReactNode;
}> = ({ title, children }) => (
  <section className="bg-white border border-secondary-200 rounded-md p-4">
    <h2 className="font-semibold text-sm uppercase tracking-wide text-secondary-700 mb-3">
      {title}
    </h2>
    <div className="space-y-2">{children}</div>
  </section>
);

export const DetailRow: React.FC<{
  label: string;
  children: React.ReactNode;
}> = ({ label, children }) => (
  <div className="flex justify-between gap-4 text-sm">
    <span className="text-secondary-500">{label}</span>
    <span className="text-secondary-900">{children}</span>
  </div>
);

export default DetailCard;
